/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Remove_Toast_Error_DescriptionInputs */

const es_components_credentials_permissions_remove_toast_error_description = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el permiso del usuario.`)
};

const en_components_credentials_permissions_remove_toast_error_description = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user permission could not be removed.`)
};

/**
* | output |
* | --- |
* | "The user permission could not be removed." |
*
* @param {Components_Credentials_Permissions_Remove_Toast_Error_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_remove_toast_error_description = /** @type {((inputs?: Components_Credentials_Permissions_Remove_Toast_Error_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Remove_Toast_Error_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_remove_toast_error_description(inputs)
	return en_components_credentials_permissions_remove_toast_error_description(inputs)
});
export { components_credentials_permissions_remove_toast_error_description as "components.credentials.permissions.remove.toast.error.description" }